import { render, staticRenderFns } from "./SelectCustomer.vue?vue&type=template&id=71e3a876"
import script from "./SelectCustomer.vue?vue&type=script&lang=js"
export * from "./SelectCustomer.vue?vue&type=script&lang=js"
import style0 from "./SelectCustomer.vue?vue&type=style&index=0&id=71e3a876&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports